 // function to format a timestamp, accepts the timestamp and an `options` object as parameters
const dayjs = require('dayjs')
module.exports = (timestamp) => {
    return dayjs(timestamp).format("MM DD YYYY [at] hh:mm a")
};
  